import axios from "../../utils/axios";

export const getCompanyInfo = async () => {
  const res = await axios.get("companyInfo/getList");

  return res;
};

export const createCompanyInfo = async (formData) => {
  const res = await axios.post("companyInfo/create", formData, {
    headers: {
      "Content-Type": "application/json",
    },
  });

  return res;
};

export const updateCompanyInfo = (id, infoData) => {
  const res = axios.put(`companyInfo/${id}`, infoData);

  return res;
};

export const deleteCompanyInfoImage = (id, imageField) => {
  const res = axios.put(`companyInfo/deleteMedia/${id}/${imageField}`);

  return res;
};
